"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, type JSX } from "react";
import { CreateWaveStepStatus } from "@/types/waves.types";
import { useDebounce } from "react-use";
export default function CreateWavesMainStepIcon(t0) {
  const $ = _c(11);
  const {
    stepStatus
  } = t0;
  const [debounceStepStatus, setDebounceStepStatus] = useState(stepStatus);
  let t1;
  if ($[0] !== stepStatus) {
    t1 = () => {
      setDebounceStepStatus(stepStatus);
    };
    $[0] = stepStatus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== stepStatus) {
    t2 = [stepStatus];
    $[2] = stepStatus;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useDebounce(t1, stepStatus === CreateWaveStepStatus.ACTIVE ? 500 : 0, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      [CreateWaveStepStatus.DONE]: "tw-ring-primary-500 tw-bg-primary-600 tw-delay-0",
      [CreateWaveStepStatus.ACTIVE]: "tw-ring-primary-500 tw-bg-primary-600 tw-shadow-[0_0_0_5px_rgba(41,112,255,0.22)] tw-delay-500",
      [CreateWaveStepStatus.PENDING]: "tw-ring-iron-700 tw-bg-iron-900 tw-delay-0"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const WRAPPER_CLASSES = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg width="11" height="9" className="tw-text-white" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M11.0965 0.390037L3.9365 7.30004L2.0365 5.27004C1.6865 4.94004 1.1365 4.92004 0.736504 5.20004C0.346504 5.49004 0.236503 6.00004 0.476503 6.41004L2.7265 10.07C2.9465 10.41 3.3265 10.62 3.7565 10.62C4.1665 10.62 4.5565 10.41 4.7765 10.07C5.1365 9.60004 12.0065 1.41004 12.0065 1.41004C12.9065 0.490037 11.8165 -0.319963 11.0965 0.380037V0.390037Z" fill="currentColor" /></svg>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="3" cy="3" r="3" fill="white" /></svg>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      [CreateWaveStepStatus.DONE]: t4,
      [CreateWaveStepStatus.ACTIVE]: t5,
      [CreateWaveStepStatus.PENDING]: <svg width="6" height="6" className="tw-text-iron-500" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="3" cy="3" r="3" fill="currentColor" /></svg>
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const components = t6;
  const t7 = `${WRAPPER_CLASSES[stepStatus]} tw-relative tw-z-10 tw-flex tw-h-6 tw-w-6 tw-transform tw-items-center tw-justify-center tw-rounded-full tw-ring-2 tw-transition tw-duration-300 tw-ease-out`;
  const t8 = components[debounceStepStatus];
  let t9;
  if ($[8] !== t7 || $[9] !== t8) {
    t9 = <span data-testid="wave-step-icon" className={t7}>{t8}</span>;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}